import React, { useState, useEffect } from 'react';
import './Header.css';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import ToastComponent from '../Toast/Toast';
import { Link, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MdAccountCircle } from 'react-icons/md';
import LanguageSwitch from '../LanguageSwitch/LanguageSwitch';
import ProfileService from '../../services/Profile/ProfileService';
import ApprovalService from '../../services/Approval/ApprovalService';

export const Header = () => {
  const { t } = useTranslation();

  const [user, setUser] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [redirecting, setRedirecting] = useState(false);
  const [showApprovals, setShowApprovals] = useState(false);
  const [, setSessionExpired] = useState(false);

  const getViDMobileUserGUIDFromOauthToken = () => {
    const oauthTokenB64 = sessionStorage.getItem('oauthTokenB64');
    if (!oauthTokenB64) return null;
    const tokenParts = oauthTokenB64.split('.');
    const jsonTokenInfo = atob(tokenParts[1]);
    const tokenInfo = JSON.parse(jsonTokenInfo);
    return tokenInfo.sub;
  };

  const doLogOut = () => {
    const userToken = sessionStorage.getItem('userToken');
    const urlReturn = sessionStorage.getItem('urlReturn');
    if (
      typeof userToken !== 'undefined' &&
      userToken === 'true' &&
      typeof urlReturn !== 'undefined' &&
      urlReturn !== 'null' &&
      urlReturn !== ''
    ) {
      setRedirecting(true);
      setTimeout(() => {
        window.location.href = atob(urlReturn);
      }, 3000);
    } else {
      setRedirect(true);
    }
    sessionStorage.clear();
  };

  const loadUserData = () => {
    ProfileService.getUserData()
      .then((res) => {
        const { userid } = res.data;
        setUser(userid);
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          setSessionExpired(true);
        }
      });
  };

  const getApprovals = () => {
    const vidGuid = getViDMobileUserGUIDFromOauthToken();
    if (!vidGuid) return;

    const searchBody = {
      Terms: { vidmobileuser: vidGuid },
    };

    ApprovalService.searchApprovals(searchBody)
      .then((documentsResponse) => {
        setShowApprovals(documentsResponse.data.length > 0);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    loadUserData();
    getApprovals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (redirect) {
    return <Redirect to={{ pathname: '/' }} />;
  }

  const inDocumentsScreen = window.location.pathname === '/documents';
  const inApprovalsScreen = window.location.pathname === '/approvals';

  return (
    <>
      <header className="App-header">
        {redirecting && (
          <ToastComponent
            onClose={() => setRedirecting(false)}
            show={redirecting}
            autohide
            delay={3000}
            title={t('general.exit')}
            message={t('general.exit-text')}
            variant="info"
            zIndex={10}
          />
        )}
        <Navbar collapseOnSelect expand="lg" bg="light" variant="dark">
          <Navbar.Brand href="/documents" className="custom-img">
            {' '}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto"></Nav>
            <Nav>
              <Nav.Link
                as={Link}
                onClick={() => window.location.replace('/documents')}
                className={inDocumentsScreen ? 'active-option' : ' '}
                to={{
                  pathname: '/documents',
                  state: { oauthTokenB64: sessionStorage.getItem('oauthTokenB64') },
                }}
              >
                {t('documents.pending')}
              </Nav.Link>
              {showApprovals && (
                <Nav.Link
                  as={Link}
                  onClick={() => window.location.replace('/approvals')}
                  className={inApprovalsScreen ? 'active-option' : ' '}
                  to={{
                    pathname: '/approvals',
                    state: { oauthTokenB64: sessionStorage.getItem('oauthTokenB64') },
                  }}
                >
                  {t('approvals.pending')}
                </Nav.Link>
              )}
              <NavDropdown
                title={
                  <div style={{ display: 'inline' }}>
                    <MdAccountCircle className="user-icon ml-5" /> {user}
                  </div>
                }
                id="collasible-nav-dropdown"
                drop="down"
              >
                <NavDropdown.Item
                  as={Link}
                  to={{
                    pathname: '/profile',
                    state: { oauthTokenB64: sessionStorage.getItem('oauthTokenB64') },
                  }}
                >
                  {t('header.profile-update')}
                </NavDropdown.Item>
                <NavDropdown.Item
                  as={Link}
                  to={{
                    pathname: '/certificates',
                    state: { oauthTokenB64: sessionStorage.getItem('oauthTokenB64') },
                  }}
                >
                  {t('header.profile-certificates')}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={() => doLogOut()}>
                  {t('header.profile-logout')}
                </NavDropdown.Item>
              </NavDropdown>
              <LanguageSwitch />
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </header>
    </>
  );
};

export default Header;
